import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import ChangePasswordModal from 'shared/ui/ChangePasswordModal'

import Style from './style'

import MainHeader from 'widget/MainHeader'

import useGetMyCompetition from 'entity/competition/useGetMyCompetition'
import {
	ROLE_COMPETITION_MANAGER,
	ROLE_FIELD_MANAGER,
	ROLE_TIMER_MANAGER,
} from 'shared/constant/lookup/role'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useRoleCookie from 'shared/model/useRoleCookie'
import DTStyle from 'shared/style/detailTableStyle'

const MyBranch = () => {
	const navigate = useNavigate()
	const [userRole] = useRoleCookie()
	const isCompetitionManager = userRole === ROLE_COMPETITION_MANAGER
	const isTimerManager = userRole === ROLE_TIMER_MANAGER
	const isFieldManager = userRole === ROLE_FIELD_MANAGER
	const [myData] = useGetMyCompetition()

	const competitationInfo = myData?.data?.store_list?.find(
		(item) => item.manager_role_flag === ROLE_COMPETITION_MANAGER
	)

	const competitionManagerData = myData?.data?.competitionManagerData

	const brandName = isCompetitionManager
		? competitationInfo?.store_name
		: myData?.data?.franchise_name ||
			competitionManagerData?.store_name ||
			myData?.data?.store_name
	const representativeContact = isCompetitionManager
		? competitationInfo?.contact
		: competitionManagerData?.contact
	const representativeName = isCompetitionManager
		? competitationInfo?.name
		: competitionManagerData?.name

	const btnList = []
	if (isCompetitionManager) {
		btnList.push(
			{
				label: '브랜드 정보 수정',
				clickEvent: () => navigate('/sub-manager/manage/edit'),
				deactive: false,
			},
			{
				label: '비밀번호 변경',
				clickEvent: () => setIsOpenChangePassword(true),
				deactive: false,
			}
		)
	}

	if (isTimerManager || isFieldManager) {
		btnList.push({
			label: '비밀번호 변경',
			clickEvent: () => setIsOpenChangePassword(true),
			deactive: false,
		})
	}

	const myDataList = [
		{
			label: 'IDX',
			value: myData?.data?.idx,
		},
		{
			label: '승인 상태',
			value: myData?.data?.is_approve ? '승인' : '미승인',
		},
		{
			label: '관리자 이름',
			value: myData?.data?.name,
		},
		{
			label: '관리자 연락처',
			value: myData?.data?.contact,
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(myData?.data?.created_at),
		},
	]

	const myCompetitionDataList = [
		{
			label: 'IDX',
			value: myData?.data?.idx,
		},
		{
			label: '승인 상태',
			value: myData?.data?.is_approve ? '승인' : '미승인',
		},
		{
			label: '관리자 이름',
			value: myData?.data?.name,
		},
		{
			label: '관리자 연락처',
			value: myData?.data?.contact,
		},
		{
			label: '브랜드 이름',
			value: myData?.data?.store_name,
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(myData?.data?.created_at),
		},
	]
	const brandInformationList = [
		{
			label: '브랜드명',
			value: brandName,
			col: 2,
		},
		{
			label: '대표자명',
			value: representativeName,
		},
		{
			label: '대표 연락처',
			value: representativeContact,
		},
	]

	const [isOpenChangePassword, setIsOpenChangePassword] = useState(false)

	return (
		<>
			<Style.Wrapper>
				<MainHeader btnList={btnList}>내 계정 관리</MainHeader>

				<Style.AreaDiv>
					<h2>내 정보</h2>
					<DTStyle.TableDiv>
						{isCompetitionManager
							? myCompetitionDataList?.map((elem, index) => (
									<DTStyle.TableElement key={index}>
										<h2>{elem?.label}</h2>
										<p>{elem?.value}</p>
									</DTStyle.TableElement>
								))
							: myDataList?.map((elem, index) => (
									<DTStyle.TableElement key={index}>
										<h2>{elem?.label}</h2>
										<p>{elem?.value}</p>
									</DTStyle.TableElement>
								))}
					</DTStyle.TableDiv>
				</Style.AreaDiv>
				{(isFieldManager || isTimerManager) && (
					<>
						<Style.AreaDiv>
							<h2>브랜드 정보</h2>
							<DTStyle.TableDiv>
								{brandInformationList?.map((elem, index) => (
									<DTStyle.TableElement
										key={index}
										$fullWidth={elem?.col === 2}
									>
										<h2>{elem?.label}</h2>
										<p>{elem?.value}</p>
									</DTStyle.TableElement>
								))}
							</DTStyle.TableDiv>
						</Style.AreaDiv>
					</>
				)}
			</Style.Wrapper>

			{isOpenChangePassword && (
				<ChangePasswordModal
					closeEvent={() => setIsOpenChangePassword(false)}
					managerId={myData?.data?.idx}
				/>
			)}
		</>
	)
}

export default MyBranch
